import { sentenceCase } from 'sentence-case';

export const isMatch = (pattern: string, name: string) => RegExp(`.*${pattern.split('').join('.*')}.*`, 'i').test(name);

// zero or above
export const isValidAmount = /^[0-9]\d*(\.\d+)?$/;

export const isValidUUID = (url = '') => url.match(/([0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$)/i);

export const isValidURL = /((http|https|ftp):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/gim;

export const isValidTime = /^[0-9]\d*(\.\d+)?$/;

export const isValidDate = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

export const isEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidCountryCode = /^(\+?\d{1,3}|\d{1,4})$/;

export const isValidPhoneNumber = /^[a-zA-Z0-9\s,.'-]{3,}$/;

export const isPostcode = /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/i;

export const isUsername = /^(?=.{6,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?![_.])$/i;

export const swapDate = birthdate => {
  const [d, m, y] = fixMaskDate(birthdate).split('/');
  return new Date(Number(y), Number(m) - 1, Number(d)).getTime();
};

export const getUnit = unit => {
  switch (unit) {
    case 'g':
      return 'g';
    case 'ml':
      return ' ml';
    default:
      return ` ${sentenceCase(unit || '')}`;
  }
};

export const fixMaskDate = wrongFormat => {
  const date = wrongFormat.replace(/\//g, '');
  return `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(4)}`;
};

export const validateBirthdate = birthdate => {
  const date = swapDate(birthdate);
  const startOfYear2000 = 949363200000;
  return !!date && date < Date.now() && date > startOfYear2000;
};

export const validateDeliverByDate = deliverByDate => {
  const date = swapDate(deliverByDate);
  const next10Days = Date.now() + 10 * 24 * 60 * 60 * 1000;
  const next10Years = Date.now() + 10 * 365 * 24 * 60 * 60 * 1000;
  return !!date && date > next10Days && date < next10Years;
};
